import $ from 'jquery';
window.$ = window.jQuery = $;

// import 'bootstrap';
// window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

import './plugins/lazy-load';
// import './image-galleries';

import './partials/line-animation';
import './partials/char-animation';
import './partials/header';
import './partials/footnotes';

import './component-sets/page-hero';
import './component-sets/chapter-hero';
import './component-sets/form-ajax';
import './component-sets/slideshow';
import './component-sets/testimonial';
// import './component-sets/image-gallery';

import './chapter-components/slideshow';
import './chapter-components/scroll-magic';
import './chapter-components/cta-asks';
import './chapter-components/aos';
import './chapter-components/mosaic';
import './chapter-components/steps-and-chapters';
